(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 6654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Transition; }
});

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/_virtual/_rollupPluginBabelHelpers.js
var _rollupPluginBabelHelpers = __webpack_require__(19642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/match.esm.js
var match_esm = __webpack_require__(133);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/render.esm.js
var render_esm = __webpack_require__(58529);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-iso-morphic-effect.esm.js
var use_iso_morphic_effect_esm = __webpack_require__(60852);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-server-handoff-complete.esm.js
var use_server_handoff_complete_esm = __webpack_require__(35989);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/hooks/use-id.esm.js
var use_id_esm = __webpack_require__(92506);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-mounted.esm.js


function useIsMounted() {
  var mounted = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
}


//# sourceMappingURL=use-is-mounted.esm.js.map

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/internal/open-closed.esm.js
var open_closed_esm = __webpack_require__(3980);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/hooks/use-is-initial-render.esm.js


function useIsInitialRender() {
  var initial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    initial.current = false;
  }, []);
  return initial.current;
}


//# sourceMappingURL=use-is-initial-render.esm.js.map

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/utils/disposables.esm.js
var disposables_esm = __webpack_require__(9472);
;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/utils/once.esm.js
function once(cb) {
  var state = {
    called: false
  };
  return function () {
    if (state.called) return;
    state.called = true;
    return cb.apply(void 0, arguments);
  };
}


//# sourceMappingURL=once.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/utils/transition.esm.js



function addClasses(node) {
  var _node$classList;

  for (var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  node && classes.length > 0 && (_node$classList = node.classList).add.apply(_node$classList, classes);
}

function removeClasses(node) {
  var _node$classList2;

  for (var _len2 = arguments.length, classes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    classes[_key2 - 1] = arguments[_key2];
  }

  node && classes.length > 0 && (_node$classList2 = node.classList).remove.apply(_node$classList2, classes);
}

var Reason;

(function (Reason) {
  Reason["Finished"] = "finished";
  Reason["Cancelled"] = "cancelled";
})(Reason || (Reason = {}));

function waitForTransition(node, done) {
  var d = (0,disposables_esm/* disposables */.k)();
  if (!node) return d.dispose; // Safari returns a comma separated list of values, so let's sort them and take the highest value.

  var _getComputedStyle = getComputedStyle(node),
      transitionDuration = _getComputedStyle.transitionDuration,
      transitionDelay = _getComputedStyle.transitionDelay;

  var _map = [transitionDuration, transitionDelay].map(function (value) {
    var _value$split$filter$m = value.split(',') // Remove falsy we can't work with
    .filter(Boolean) // Values are returned as `0.3s` or `75ms`
    .map(function (v) {
      return v.includes('ms') ? parseFloat(v) : parseFloat(v) * 1000;
    }).sort(function (a, z) {
      return z - a;
    }),
        _value$split$filter$m2 = _value$split$filter$m[0],
        resolvedValue = _value$split$filter$m2 === void 0 ? 0 : _value$split$filter$m2;

    return resolvedValue;
  }),
      durationMs = _map[0],
      delaysMs = _map[1]; // Waiting for the transition to end. We could use the `transitionend` event, however when no
  // actual transition/duration is defined then the `transitionend` event is not fired.
  //
  // TODO: Downside is, when you slow down transitions via devtools this timeout is still using the
  // full 100% speed instead of the 25% or 10%.


  if (durationMs !== 0) {
    d.setTimeout(function () {
      done(Reason.Finished);
    }, durationMs + delaysMs);
  } else {
    // No transition is happening, so we should cleanup already. Otherwise we have to wait until we
    // get disposed.
    done(Reason.Finished);
  } // If we get disposed before the timeout runs we should cleanup anyway


  d.add(function () {
    return done(Reason.Cancelled);
  });
  return d.dispose;
}

function transition(node, base, from, to, entered, done) {
  var d = (0,disposables_esm/* disposables */.k)();

  var _done = done !== undefined ? once(done) : function () {};

  removeClasses.apply(void 0, [node].concat(entered));
  addClasses.apply(void 0, [node].concat(base, from));
  d.nextFrame(function () {
    removeClasses.apply(void 0, [node].concat(from));
    addClasses.apply(void 0, [node].concat(to));
    d.add(waitForTransition(node, function (reason) {
      removeClasses.apply(void 0, [node].concat(to, base));
      addClasses.apply(void 0, [node].concat(entered));
      return _done(reason);
    }));
  }); // Once we get disposed, we should ensure that we cleanup after ourselves. In case of an unmount,
  // the node itself will be nullified and will be a no-op. In case of a full transition the classes
  // are already removed which is also a no-op. However if you go from enter -> leave mid-transition
  // then we have some leftovers that should be cleaned.

  d.add(function () {
    return removeClasses.apply(void 0, [node].concat(base, from, to, entered));
  }); // When we get disposed early, than we should also call the done method but switch the reason.

  d.add(function () {
    return _done(Reason.Cancelled);
  });
  return d.dispose;
}


//# sourceMappingURL=transition.esm.js.map

;// CONCATENATED MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js












function useSplitClasses(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return (0,react.useMemo)(function () {
    return classes.split(' ').filter(function (className) {
      return className.trim().length > 1;
    });
  }, [classes]);
}

var TransitionContext = /*#__PURE__*/(0,react.createContext)(null);
TransitionContext.displayName = 'TransitionContext';
var TreeStates;

(function (TreeStates) {
  TreeStates["Visible"] = "visible";
  TreeStates["Hidden"] = "hidden";
})(TreeStates || (TreeStates = {}));

function useTransitionContext() {
  var context = (0,react.useContext)(TransitionContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.');
  }

  return context;
}

function useParentNesting() {
  var context = (0,react.useContext)(NestingContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.');
  }

  return context;
}

var NestingContext = /*#__PURE__*/(0,react.createContext)(null);
NestingContext.displayName = 'NestingContext';

function hasChildren(bag) {
  if ('children' in bag) return hasChildren(bag.children);
  return bag.current.filter(function (_ref) {
    var state = _ref.state;
    return state === TreeStates.Visible;
  }).length > 0;
}

function useNesting(done) {
  var doneRef = (0,react.useRef)(done);
  var transitionableChildren = (0,react.useRef)([]);
  var mounted = useIsMounted();
  (0,react.useEffect)(function () {
    doneRef.current = done;
  }, [done]);
  var unregister = (0,react.useCallback)(function (childId, strategy) {
    var _match;

    if (strategy === void 0) {
      strategy = render_esm/* RenderStrategy.Hidden */.l4.Hidden;
    }

    var idx = transitionableChildren.current.findIndex(function (_ref2) {
      var id = _ref2.id;
      return id === childId;
    });
    if (idx === -1) return;
    (0,match_esm/* match */.E)(strategy, (_match = {}, _match[render_esm/* RenderStrategy.Unmount */.l4.Unmount] = function () {
      transitionableChildren.current.splice(idx, 1);
    }, _match[render_esm/* RenderStrategy.Hidden */.l4.Hidden] = function () {
      transitionableChildren.current[idx].state = TreeStates.Hidden;
    }, _match));

    if (!hasChildren(transitionableChildren) && mounted.current) {
      doneRef.current == null ? void 0 : doneRef.current();
    }
  }, [doneRef, mounted, transitionableChildren]);
  var register = (0,react.useCallback)(function (childId) {
    var child = transitionableChildren.current.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });

    if (!child) {
      transitionableChildren.current.push({
        id: childId,
        state: TreeStates.Visible
      });
    } else if (child.state !== TreeStates.Visible) {
      child.state = TreeStates.Visible;
    }

    return function () {
      return unregister(childId, render_esm/* RenderStrategy.Unmount */.l4.Unmount);
    };
  }, [transitionableChildren, unregister]);
  return (0,react.useMemo)(function () {
    return {
      children: transitionableChildren,
      register: register,
      unregister: unregister
    };
  }, [register, unregister, transitionableChildren]);
}

function noop() {}

var eventNames = ['beforeEnter', 'afterEnter', 'beforeLeave', 'afterLeave'];

function ensureEventHooksExist(events) {
  var result = {};

  for (var _iterator = (0,_rollupPluginBabelHelpers/* createForOfIteratorHelperLoose */.Ul)(eventNames), _step; !(_step = _iterator()).done;) {
    var _events$name;

    var name = _step.value;
    result[name] = (_events$name = events[name]) != null ? _events$name : noop;
  }

  return result;
}

function useEvents(events) {
  var eventsRef = (0,react.useRef)(ensureEventHooksExist(events));
  (0,react.useEffect)(function () {
    eventsRef.current = ensureEventHooksExist(events);
  }, [events]);
  return eventsRef;
} // ---


var DEFAULT_TRANSITION_CHILD_TAG = 'div';
var TransitionChildRenderFeatures = render_esm/* Features.RenderStrategy */.AN.RenderStrategy;

function TransitionChild(props) {
  var _match3;

  var beforeEnter = props.beforeEnter,
      afterEnter = props.afterEnter,
      beforeLeave = props.beforeLeave,
      afterLeave = props.afterLeave,
      enter = props.enter,
      enterFrom = props.enterFrom,
      enterTo = props.enterTo,
      entered = props.entered,
      leave = props.leave,
      leaveFrom = props.leaveFrom,
      leaveTo = props.leaveTo,
      rest = (0,_rollupPluginBabelHelpers/* objectWithoutPropertiesLoose */.gK)(props, ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"]);

  var container = (0,react.useRef)(null);

  var _useState = (0,react.useState)(TreeStates.Visible),
      state = _useState[0],
      setState = _useState[1];

  var strategy = rest.unmount ? render_esm/* RenderStrategy.Unmount */.l4.Unmount : render_esm/* RenderStrategy.Hidden */.l4.Hidden;

  var _useTransitionContext = useTransitionContext(),
      show = _useTransitionContext.show,
      appear = _useTransitionContext.appear;

  var _useParentNesting = useParentNesting(),
      register = _useParentNesting.register,
      unregister = _useParentNesting.unregister;

  var initial = useIsInitialRender();
  var id = (0,use_id_esm/* useId */.M)();
  var isTransitioning = (0,react.useRef)(false);
  var nesting = useNesting(function () {
    // When all children have been unmounted we can only hide ourselves if and only if we are not
    // transitioning ourselves. Otherwise we would unmount before the transitions are finished.
    if (!isTransitioning.current) {
      setState(TreeStates.Hidden);
      unregister(id);
      events.current.afterLeave();
    }
  });
  (0,use_iso_morphic_effect_esm/* useIsoMorphicEffect */.e)(function () {
    if (!id) return;
    return register(id);
  }, [register, id]);
  (0,use_iso_morphic_effect_esm/* useIsoMorphicEffect */.e)(function () {
    var _match2;

    // If we are in another mode than the Hidden mode then ignore
    if (strategy !== render_esm/* RenderStrategy.Hidden */.l4.Hidden) return;
    if (!id) return; // Make sure that we are visible

    if (show && state !== TreeStates.Visible) {
      setState(TreeStates.Visible);
      return;
    }

    (0,match_esm/* match */.E)(state, (_match2 = {}, _match2[TreeStates.Hidden] = function () {
      return unregister(id);
    }, _match2[TreeStates.Visible] = function () {
      return register(id);
    }, _match2));
  }, [state, id, register, unregister, show, strategy]);
  var enterClasses = useSplitClasses(enter);
  var enterFromClasses = useSplitClasses(enterFrom);
  var enterToClasses = useSplitClasses(enterTo);
  var enteredClasses = useSplitClasses(entered);
  var leaveClasses = useSplitClasses(leave);
  var leaveFromClasses = useSplitClasses(leaveFrom);
  var leaveToClasses = useSplitClasses(leaveTo);
  var events = useEvents({
    beforeEnter: beforeEnter,
    afterEnter: afterEnter,
    beforeLeave: beforeLeave,
    afterLeave: afterLeave
  });
  var ready = (0,use_server_handoff_complete_esm/* useServerHandoffComplete */.H)();
  (0,react.useEffect)(function () {
    if (ready && state === TreeStates.Visible && container.current === null) {
      throw new Error('Did you forget to passthrough the `ref` to the actual DOM node?');
    }
  }, [container, state, ready]); // Skipping initial transition

  var skip = initial && !appear;
  (0,use_iso_morphic_effect_esm/* useIsoMorphicEffect */.e)(function () {
    var node = container.current;
    if (!node) return;
    if (skip) return;
    isTransitioning.current = true;
    if (show) events.current.beforeEnter();
    if (!show) events.current.beforeLeave();
    return show ? transition(node, enterClasses, enterFromClasses, enterToClasses, enteredClasses, function (reason) {
      isTransitioning.current = false;
      if (reason === Reason.Finished) events.current.afterEnter();
    }) : transition(node, leaveClasses, leaveFromClasses, leaveToClasses, enteredClasses, function (reason) {
      isTransitioning.current = false;
      if (reason !== Reason.Finished) return; // When we don't have children anymore we can safely unregister from the parent and hide
      // ourselves.

      if (!hasChildren(nesting)) {
        setState(TreeStates.Hidden);
        unregister(id);
        events.current.afterLeave();
      }
    });
  }, [events, id, isTransitioning, unregister, nesting, container, skip, show, enterClasses, enterFromClasses, enterToClasses, leaveClasses, leaveFromClasses, leaveToClasses]);
  var propsWeControl = {
    ref: container
  };
  var passthroughProps = rest;
  return react.createElement(NestingContext.Provider, {
    value: nesting
  }, react.createElement(open_closed_esm/* OpenClosedProvider */.up, {
    value: (0,match_esm/* match */.E)(state, (_match3 = {}, _match3[TreeStates.Visible] = open_closed_esm/* State.Open */.ZM.Open, _match3[TreeStates.Hidden] = open_closed_esm/* State.Closed */.ZM.Closed, _match3))
  }, (0,render_esm/* render */.sY)({
    props: (0,_rollupPluginBabelHelpers/* extends */.gY)({}, passthroughProps, propsWeControl),
    defaultTag: DEFAULT_TRANSITION_CHILD_TAG,
    features: TransitionChildRenderFeatures,
    visible: state === TreeStates.Visible,
    name: 'Transition.Child'
  })));
}

function Transition(props) {
  // @ts-expect-error
  var show = props.show,
      _props$appear = props.appear,
      appear = _props$appear === void 0 ? false : _props$appear,
      unmount = props.unmount,
      passthroughProps = (0,_rollupPluginBabelHelpers/* objectWithoutPropertiesLoose */.gK)(props, ["show", "appear", "unmount"]);

  var usesOpenClosedState = (0,open_closed_esm/* useOpenClosed */.oJ)();

  if (show === undefined && usesOpenClosedState !== null) {
    var _match4;

    show = (0,match_esm/* match */.E)(usesOpenClosedState, (_match4 = {}, _match4[open_closed_esm/* State.Open */.ZM.Open] = true, _match4[open_closed_esm/* State.Closed */.ZM.Closed] = false, _match4));
  }

  if (![true, false].includes(show)) {
    throw new Error('A <Transition /> is used but it is missing a `show={true | false}` prop.');
  }

  var _useState2 = (0,react.useState)(show ? TreeStates.Visible : TreeStates.Hidden),
      state = _useState2[0],
      setState = _useState2[1];

  var nestingBag = useNesting(function () {
    setState(TreeStates.Hidden);
  });
  var initial = useIsInitialRender();
  var transitionBag = (0,react.useMemo)(function () {
    return {
      show: show,
      appear: appear || !initial
    };
  }, [show, appear, initial]);
  (0,react.useEffect)(function () {
    if (show) {
      setState(TreeStates.Visible);
    } else if (!hasChildren(nestingBag)) {
      setState(TreeStates.Hidden);
    }
  }, [show, nestingBag]);
  var sharedProps = {
    unmount: unmount
  };
  return react.createElement(NestingContext.Provider, {
    value: nestingBag
  }, react.createElement(TransitionContext.Provider, {
    value: transitionBag
  }, (0,render_esm/* render */.sY)({
    props: (0,_rollupPluginBabelHelpers/* extends */.gY)({}, sharedProps, {
      as: react.Fragment,
      children: react.createElement(TransitionChild, Object.assign({}, sharedProps, passthroughProps))
    }),
    defaultTag: react.Fragment,
    features: TransitionChildRenderFeatures,
    visible: state === TreeStates.Visible,
    name: 'Transition'
  })));
}

Transition.Child = function Child(props) {
  var hasTransitionContext = (0,react.useContext)(TransitionContext) !== null;
  var hasOpenClosedContext = (0,open_closed_esm/* useOpenClosed */.oJ)() !== null;
  return !hasTransitionContext && hasOpenClosedContext ? react.createElement(Transition, Object.assign({}, props)) : react.createElement(TransitionChild, Object.assign({}, props));
};

Transition.Root = Transition;


//# sourceMappingURL=transition.esm.js.map


/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(32124);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(6654);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container/index.js + 1 modules
var Container = __webpack_require__(12556);
// EXTERNAL MODULE: ./src/components/ProtectedPage/index.js + 1 modules
var ProtectedPage = __webpack_require__(26212);
;// CONCATENATED MODULE: ./src/components/CustomerLogos/CustomerLogos.js




function CustomerLogos(param) {
    var customers = param.customers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "lg:px-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4",
                children: customers.map(function(param, index) {
                    var logo = param.logo, title = param.title, url = param.url;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo,
                            alt: title,
                            width: 300,
                            height: 190
                        })
                    }, "customer-logo-".concat(url, "-").concat(index));
                })
            })
        })
    });
};
CustomerLogos.defaultProps = {
    customers: []
};
CustomerLogos.propTypes = {
    customers: prop_types_default().arrayOf(prop_types_default().shape({
        logo: prop_types_default().oneOfType([
            (prop_types_default()).string,
            (prop_types_default()).object
        ]),
        title: (prop_types_default()).string,
        url: (prop_types_default()).string
    }))
};

;// CONCATENATED MODULE: ./src/components/CustomerLogos/customers.js
var iess = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/iess_y8lsit.png",
    title: "Instituto Ecuatoriano de Seguridad Social",
    url: "https://www.iess.gob.ec/"
};
var nestle = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/nestle_han8oo.png",
    title: "Nestle Ecuador",
    url: "https://www.nestle.com.ec/"
};
var soltein = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/soltein_ameuwh.png",
    title: "Soltein",
    url: "https://www.soltein.net/"
};
var soyHincha = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/soy-hincha_ukafpv.png",
    title: "Soy Hincha",
    url: "https://www.soyhincha.com/"
};
var udla = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/udla_uxfsf4.png",
    title: "Universidad de las Am\xe9ricas",
    url: "https://www.udla.edu.ec/"
};
var modernaAlimentos = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/moderna-alimentos_ik0txc.png",
    title: "Alimentos Moderna",
    url: "https://www.moderna.com.ec/"
};
var stackbuilders = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/stackbuilders_rtrxnf.png",
    title: "Stack Builders",
    url: "https://www.stackbuilders.com/"
};
var technisys = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/technisys_y81vht.png",
    title: "Stack Builders"
};
var salica = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/salica_giba20.png",
    title: "Stack Builders"
};
var klever = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/klever_bcqx5y.png",
    title: "Stack Builders"
};
var procredit = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994100/partners/customers/banco-procredit_uutxxk.png",
    title: "Banco ProCredit"
};
var farmaenlace = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/farmaenlace_ojvihs.png",
    title: "Stack Builders"
};
var megaprofer = {
    logo: "https://res.cloudinary.com/aibesorg/image/upload/v1644994099/partners/customers/megaprofer_s5bh4l.png",
    title: "Megaprofer"
};

;// CONCATENATED MODULE: ./src/components/CustomerLogos/index.js


/* harmony default export */ var components_CustomerLogos = (CustomerLogos);


;// CONCATENATED MODULE: ./src/lib/useInterval.js

function useInterval(callback, delay) {
    (0,react.useEffect)(function() {
        if (!delay && delay !== 0) {
            return;
        }
        var id = setInterval(function() {
            return callback();
        }, delay);
        return function() {
            return clearInterval(id);
        };
    }, [
        callback,
        delay
    ]);
}
/* harmony default export */ var lib_useInterval = (useInterval);

;// CONCATENATED MODULE: ./public/credly.webp
/* harmony default export */ var credly = ({"src":"/_next/static/media/credly.0fee38db.webp","height":449,"width":900,"blurDataURL":"data:image/webp;base64,UklGRmAAAABXRUJQVlA4WAoAAAAQAAAABwAAAwAAQUxQSCEAAAAAY5gGABOTTABrIWSAa5hQPH9udJOYmoGTAAAAAAAWojoAVlA4IBgAAAAwAQCdASoIAAQAAkA4JaQAA3AA/vshgAA="});
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./src/pages/index.js











var indexHeroCarouselInfo = [
    {
        key: "official-scrum-trainer-001",
        alt: "official-scrum-trainer-001",
        image: "https://res.cloudinary.com/aibesorg/image/upload/v1644994105/partners/trainer-home-001_zytvyh.png",
        color: "bg-yellow-500"
    },
    {
        key: "official-scrum-trainer-002",
        alt: "official-scrum-trainer-002",
        image: "https://res.cloudinary.com/aibesorg/image/upload/v1644994104/partners/trainer-home-003_bugzfb.png",
        color: "bg-red-500"
    },
    {
        key: "official-scrum-trainer-003",
        alt: "official-scrum-trainer-003",
        image: "https://res.cloudinary.com/aibesorg/image/upload/v1644994103/partners/trainer-home-002_geavqb.png",
        color: "bg-emerald-500"
    }, 
];
function IndexHeroCarouselClouds(param) {
    var show = param.show, itm = param.itm, zIndex = param.zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
        show: show,
        enter: "transition-all duration-1000",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-1000",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        unmount: false,
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute",
            style: {
                zIndex: zIndex
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "601",
                height: "592",
                viewBox: "0 0 601 592",
                fill: "none",
                className: (0,clsx_m/* default */.Z)("absolute top-0 right-0 mt-20 mr-20 blur-3xl fill-current", itm.color),
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M382.321 0.0323192C213.172 2.52387 115.569 68.8961 87.9103 101.771C-56.0459 241.402 -10.0599 194.166 130.897 238.807C271.854 283.447 139.894 302.653 271.854 506.13C403.814 709.607 437.304 506.13 547.77 362.865C658.237 219.601 593.756 -3.08213 382.321 0.0323192Z"
                })
            })
        })
    });
}
IndexHeroCarouselClouds.defaultProps = {
    show: false,
    zIndex: 0
};
IndexHeroCarouselClouds.propTypes = {
    show: (prop_types_default()).bool,
    zIndex: (prop_types_default()).number,
    itm: prop_types_default().shape({
        image: (prop_types_default()).object,
        color: (prop_types_default()).string
    }).isRequired
};
function IndexHeroCarouselImage(param) {
    var show = param.show, alt = param.alt, image = param.image, zIndex = param.zIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition_esm/* Transition */.u, {
        show: show,
        enter: "transition-all duration-1000",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-1000",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        unmount: false,
        appear: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute inset-0 flex items-center justify-center pb-20",
            style: {
                zIndex: zIndex
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                width: 400,
                height: 500,
                alt: alt,
                src: image,
                quality: 100
            })
        })
    });
}
IndexHeroCarouselImage.defaultProps = {
    show: false,
    zIndex: 0
};
IndexHeroCarouselImage.propTypes = {
    show: (prop_types_default()).bool,
    zIndex: (prop_types_default()).number,
    image: (prop_types_default()).object.isRequired
};
var CAROUSEL_INTERVAL = 5000;
function IndexHeroCarousel() {
    var ref = (0,react.useState)(0), currentImageIndex = ref[0], setNextImageIndex = ref[1];
    var ref1 = (0,react.useState)(CAROUSEL_INTERVAL), interval = ref1[0], setInterval = ref1[1];
    lib_useInterval(function() {
        setNextImageIndex(function(prev) {
            var next = prev + 1;
            if (next > indexHeroCarouselInfo.length - 1) {
                next = 0;
            }
            return next;
        });
    }, interval);
    (0,react.useEffect)(function() {
        var handler = function handler() {
            if (document.hidden) {
                setInterval(null);
            } else {
                setInterval(CAROUSEL_INTERVAL);
            }
        };
        document.addEventListener("visibilitychange", handler);
        return function() {
            return document.removeEventListener("visibilitychange", handler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ml-20 inline-flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "800",
                height: "800",
                viewBox: "0 0 1067 1067",
                fill: "none",
                className: "relative z-10",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M533.5 1066.5C827.868 1066.5 1066.5 827.868 1066.5 533.5C1066.5 239.132 827.868 0.5 533.5 0.5C239.132 0.5 0.5 239.132 0.5 533.5C0.5 827.868 239.132 1066.5 533.5 1066.5Z",
                        fill: "white",
                        fillOpacity: "0.2",
                        stroke: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M533 969.5C774.072 969.5 969.5 774.072 969.5 533C969.5 291.928 774.072 96.5 533 96.5C291.928 96.5 96.5 291.928 96.5 533C96.5 774.072 291.928 969.5 533 969.5Z",
                        fill: "white",
                        fillOpacity: "0.5",
                        stroke: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M533 877C722.986 877 877 722.986 877 533C877 343.014 722.986 189 533 189C343.014 189 189 343.014 189 533C189 722.986 343.014 877 533 877Z",
                        fill: "white",
                        fillOpacity: "0.5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M668.244 956.489C672.245 956.489 675.489 953.245 675.489 949.244C675.489 945.243 672.245 942 668.244 942C664.243 942 661 945.243 661 949.244C661 953.245 664.243 956.489 668.244 956.489Z",
                        fill: "#61D7AC"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M668.244 960.75C674.599 960.75 679.75 955.599 679.75 949.244C679.75 942.89 674.599 937.739 668.244 937.739C661.89 937.739 656.739 942.89 656.739 949.244C656.739 955.599 661.89 960.75 668.244 960.75Z",
                        stroke: "#61D7AC",
                        strokeOpacity: "0.1",
                        strokeWidth: "8.52288"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M208.244 666.489C212.245 666.489 215.489 663.245 215.489 659.244C215.489 655.243 212.245 652 208.244 652C204.243 652 201 655.243 201 659.244C201 663.245 204.243 666.489 208.244 666.489Z",
                        fill: "#22C55E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M208.244 670.75C214.599 670.75 219.75 665.599 219.75 659.244C219.75 652.89 214.599 647.739 208.244 647.739C201.89 647.739 196.739 652.89 196.739 659.244C196.739 665.599 201.89 670.75 208.244 670.75Z",
                        stroke: "#22C55E",
                        strokeOpacity: "0.1",
                        strokeWidth: "8.52288"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M392.244 123.489C396.245 123.489 399.489 120.245 399.489 116.244C399.489 112.243 396.245 109 392.244 109C388.243 109 385 112.243 385 116.244C385 120.245 388.243 123.489 392.244 123.489Z",
                        fill: "#22C55E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M392.244 127.75C398.599 127.75 403.75 122.599 403.75 116.244C403.75 109.89 398.599 104.739 392.244 104.739C385.89 104.739 380.739 109.89 380.739 116.244C380.739 122.599 385.89 127.75 392.244 127.75Z",
                        stroke: "#22C55E",
                        strokeOpacity: "0.1",
                        strokeWidth: "8.52288"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M901.244 152.489C905.245 152.489 908.489 149.245 908.489 145.244C908.489 141.243 905.245 138 901.244 138C897.243 138 894 141.243 894 145.244C894 149.245 897.243 152.489 901.244 152.489Z",
                        fill: "#22C55E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M901.244 156.75C907.599 156.75 912.75 151.599 912.75 145.244C912.75 138.89 907.599 133.739 901.244 133.739C894.89 133.739 889.739 138.89 889.739 145.244C889.739 151.599 894.89 156.75 901.244 156.75Z",
                        stroke: "#22C55E",
                        strokeOpacity: "0.1",
                        strokeWidth: "8.52288"
                    })
                ]
            }),
            indexHeroCarouselInfo.map(function(itm, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexHeroCarouselClouds, {
                    show: currentImageIndex === idx,
                    zIndex: idx,
                    itm: itm
                }, "".concat(itm.key, "-svg-shape"));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 flex items-center justify-center z-20",
                children: indexHeroCarouselInfo.map(function(itm, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexHeroCarouselImage, {
                        show: currentImageIndex === idx,
                        zIndex: idx,
                        alt: itm.alt,
                        image: itm.image
                    }, itm.key);
                })
            })
        ]
    });
}
function IndexPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-green-100 bg-gradient-to-tl from-green-200 to-green-50 relative overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        className: "py-10 relative z-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-10 lg:py-20",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 lg:grid-cols-12 relative z-10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "space-y-6 lg:space-y-8 relative z-20 lg:col-span-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "font-semibold text-lg lg:text-xl text-green-500",
                                                children: "Comunidad de socios"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-4xl lg:text-5xl xl:text-6xl",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "leading-tight font-display font-extrabold tracking-tight",
                                                    children: "Hagamos crecer juntos la gran familia que somos"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-lg lg:text-xl lg:pr-20",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-gray-800 leading-relaxed",
                                                    children: "Como parte de nuestra comunidad global, con nuestros socios trabajamos juntos para acelerar el impacto en la adopci\xf3n de la cultura \xe1gil de nuestros clientes, mejorar sus habilidades y obtener m\xe1s y mejores resultados."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center lg:pt-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "inline-flex bg-green-500 text-white rounded-full px-6 py-2 lg:px-8 lg:py-3 lg:text-lg font-semibold hover:bg-green-600 focus:bg-green-600 focus:ring-4 focus:ring-green-600 focus:ring-opacity-20",
                                                    href: "https://www.aibes.org/programa-de-socios/",
                                                    role: "button",
                                                    children: "Aplica al programa de socios"
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute z-0 inset-0 pointer-events-none hidden md:grid grid-cols-12 items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-6 col-start-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexHeroCarousel, {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-2/4 h-2/4 bg-gradient-to-l from-green-200 to-transparent absolute right-0 top-0 z-0 blur-3xl mt-40"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-2/6 h-2/6 bg-gradient-to-br from-green-200 to-white absolute right-0 bottom-0 z-0 blur-3xl mt-40"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white py-10 lg:py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "space-y-10",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-center text-lg lg:text-2xl font-semibold lg:font-medium tracking-tight",
                            children: "Con la confianza de empresas e instituciones reconocidas"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CustomerLogos, {
                            customers: [
                                udla,
                                iess,
                                procredit,
                                nestle,
                                soltein,
                                modernaAlimentos,
                                soyHincha,
                                farmaenlace,
                                klever,
                                stackbuilders,
                                technisys,
                                megaprofer, 
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "text-lg font-semibold text-green-500 hover:text-green-600 inline-flex items-center space-x-2",
                                href: "//aibes.org/clientes",
                                role: "button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Todos nuestros clientes"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        className: "h-5 w-5 text-gray-300",
                                        viewBox: "0 0 20 20",
                                        fill: "currentColor",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-10 lg:py-20 xl:py-32 text-white relative overflow-hidden",
                style: {
                    backgroundColor: "#005850"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: "relative z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:col-span-6 lg:col-span-7",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col space-y-6 lg:space-y-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col space-y-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-3xl lg:text-5xl",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "leading-tight font-semibold lg:font-bold",
                                                            children: "Insignias digitales de certificaciones"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-white text-opacity-80 text-lg lg:text-xl",
                                                        children: "Todas nuestras certificaciones poseen insignias digitales en la red de insignias digitales m\xe1s grande del mundo."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "inline-flex rounded-full text-white font-medium lg:font-semibold border-2 border-white border-opacity-40 px-4 py-2 leading-4 hover:bg-white hover:text-gray-900 focus:bg-white focus:text-gray-900 focus:outline-none focus:ring-4 focus:ring-white focus:ring-opacity-20 hover:border-transparent focus:border-transparent",
                                                    href: "https://www.credly.com/organizations/asociacion-iberoamericana-de-scrum/badges",
                                                    role: "button",
                                                    children: "Conoce nuestras insignias en Credly"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:col-span-6 lg:col-span-5 flex items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "p-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: credly,
                                            alt: "Credly"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-0 bottom-0 right-0 w-2/4 transform -skew-y-12 flex flex-col items-end justify-end",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-2/6 h-28 bg-gradient-to-l from-white to-transparent opacity-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-28 bg-gradient-to-l from-white to-transparent opacity-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-2/4 h-28 bg-gradient-to-l from-white to-transparent opacity-20"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-3/5 h-28 bg-gradient-to-l from-white to-transparent opacity-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-2/6 h-28 bg-gradient-to-l from-white to-transparent opacity-10"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var pages = ((0,ProtectedPage/* withAuthenticatedUser */.c)(IndexPage, {
    doNotRedirectToLogin: true
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);